import { defineMessages } from 'react-intl';

export default defineMessages({
  //GET STARTED
  charityVettingEmailRequired: {
    id: 'charity.vetting.email.required',
    defaultMessage: 'Please enter an email address',
  },
  charityVettingEmailInvalid: {
    id: 'charity.vetting.email.invalid',
    defaultMessage: 'Please enter a valid email address – e.g. “name@mail.com”',
  },
  charityVettingCountryRequired: {
    id: 'charity.vetting.country.required',
    defaultMessage: 'Please select a country',
  },
  // SEARCH
  charityVettingSearchTerm: {
    id: 'charity.vetting.search.term',
    defaultMessage:
      'Find your organisation using the search field before you continue. If it’s not listed, tap "Can’t find your organisation?".',
  },
  //CHARITY DETAILS
  charityVettingNameRequired: {
    id: 'charity.vetting.name.required',
    defaultMessage: "Please enter your organisation's name",
  },
  charityVettingAddressRequired: {
    id: 'charity.vetting.address.required',
    defaultMessage: "Please enter your organisation's address",
  },
  charityVettingPhoneNumberRequired: {
    id: 'charity.vetting.phone.number.required',
    defaultMessage: "Please enter your organisation's phone number",
  },
  charityVettingPhoneNumberInvalid: {
    id: 'charity.vetting.phone.number.invalid',
    defaultMessage: 'Invalid format. The phone number must contain {length} digits.',
  },
  charityVettingPhoneNumberValid: {
    id: 'charity.vetting.phone.number.valid',
    defaultMessage: 'Please enter a valid phone number',
  },
  charityVettingCityRequired: {
    id: 'charity.vetting.city.required',
    defaultMessage: "Please enter your organisation's city",
  },
  charityVettingPostalCodeRequired: {
    id: 'charity.vetting.postal.code.required',
    defaultMessage: "Please enter your organisation's postal code",
  },
  //ORGANISATION TYPE
  charityVettingOrganisationTypeLabel: {
    id: 'charity.vetting.organisation.type.label',
    defaultMessage: 'Which type of organisation do you represent?',
  },
  charityVettingDialogOrganisationTypeTitle: {
    id: 'charity.vetting.dialog.organisation.type.title',
    defaultMessage: 'Organisation types',
  },
  charityVettingDialogOrganisationTypeText: {
    id: 'charity.vetting.dialog.organisation.type.text',
    defaultMessage:
      "If you're unsure about which category best describes your organisation, you can learn more about each one by following the links below.",
  },
  charityVettingOrganisationInformationAssociation: {
    id: 'charity.vetting.charity.information.association',
    defaultMessage: 'Association',
  },
  charityVettingOrganisationInformationFoundation: {
    id: 'charity.vetting.charity.information.foundation',
    defaultMessage: 'Foundation',
  },
  // SOCIAL MEDIA
  charityVettingValidSocialMediaLink: {
    id: 'charity.vetting.valid.social.media.link',
    defaultMessage: 'Please enter a valid URL',
  },
  // ERROR
  charityVettingSomethingWentWrong: {
    id: 'charity.vetting.generic.error',
    defaultMessage: 'Something went wrong. Please try again later.',
  },
});
